import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';

// *******************************************************************************
// Layouts

import { Layout1Component } from './layout/layout-1/layout-1.component';

// *******************************************************************************
// Pages

import { HomeComponent } from './home/home.component';
import { Page2Component } from './page-2/page-2.component';
import {Page3Component} from './page3/page3.component';
import {AuthenticationLoginAndRegisterComponent} from './authentication-login-and-register/authentication-login-and-register.component';
import {AuthGuardService} from './auth-guard.service';
import {CreateCertificateComponent} from './create-certificate/create-certificate.component';
import {ViewCertificateComponent} from './view-certificate/view-certificate.component';
import {ProfessionalListComponent} from './professional-list/professional-list.component';
import {StatisticsPageComponent} from './statistics-page/statistics-page.component';
import {CandidatePageComponent} from './candidate-page/candidate-page.component';
import {VacancyPageComponent} from './vacancy-page/vacancy-page.component';
import {VacancyDetailPageComponent} from './vacancy-detail-page/vacancy-detail-page.component';
import {CoursesOverviewPageComponent} from './courses-overview-page/courses-overview-page.component';

// *******************************************************************************
// Routes

const routes: Routes = [

  { path: '', component: Layout1Component, pathMatch: 'full', children: [
    { path: '', component: HomeComponent },
  ], canActivate: [AuthGuardService]},

  { path: 'certificates', component: Layout1Component, children: [
      { path: '', component: Page2Component },
    { path: ':userId', component: Page2Component },
  ], canActivate: [AuthGuardService]},

  { path: 'professional-companies', component: Layout1Component, children: [
      { path: '', component: Page3Component },
    ], canActivate: [AuthGuardService]},

  { path: 'create-certificate', component: Layout1Component, children: [
      { path: '', component: CreateCertificateComponent },
    ], canActivate: [AuthGuardService]},

  { path: 'view-certificate', component: Layout1Component, children: [
      { path: ':id', component: ViewCertificateComponent },
    ], canActivate: [AuthGuardService]},

  { path: 'professionals', component: Layout1Component, children: [
      { path: '', component: ProfessionalListComponent },
    ], canActivate: [AuthGuardService]},

  { path: 'candidates', component: Layout1Component, children: [
      { path: '', component: CandidatePageComponent },
    ], canActivate: [AuthGuardService]},

  { path: 'vacancies', component: Layout1Component, children: [
      { path: '', component: VacancyPageComponent },
    ], canActivate: [AuthGuardService]},

  { path: 'vacancy', component: Layout1Component, children: [
      { path: ':id', component: VacancyDetailPageComponent },
    ], canActivate: [AuthGuardService]},

  { path: 'statistics', component: Layout1Component, children: [
      { path: '', component: StatisticsPageComponent },
    ], canActivate: [AuthGuardService]},

  { path: 'courses', component: Layout1Component, children: [
      { path: '', component: CoursesOverviewPageComponent },
    ], canActivate: [AuthGuardService]},

  { path: 'login', component: AuthenticationLoginAndRegisterComponent },

  // 404 Not Found page
  { path: '**', component: NotFoundComponent }

];

// *******************************************************************************
//

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
